import React from 'react'
import {connect} from 'react-redux'
import {change as changeFieldValue, reduxForm} from 'redux-form';
import selecionarUsuario from '../../../actions/usuario/selecionarUsuario';
import exclurUsuarioPlataformaWeb from '../../../actions/usuario/exclurUsuarioPlataformaWeb';
import desativarUsuarioPlataformaWeb from '../../../actions/usuario/desativarUsuarioPlataformaWeb';
import ativarUsuarioPlataformaWeb from '../../../actions/usuario/ativarUsuarioPlataformaWeb';
import {showSuccessMsg} from '../../../util/messagesUtil';
import resetarSenhaUsuarioPlataformaWeb from '../../../actions/usuario/resetarSenhaUsuarioPlataformaWeb';

const ModalConfirmacaoExclusaoUsuario = ({excluir, usuario}) => (
    <div className="modal fade" id="modalConfirmacaoExclusaoUsuario" tabIndex="-1" role="dialog"
         aria-labelledby="modalConfirmacao" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-body texto-centralizado">
                    <p>Deseja excluir o usuário <strong>{usuario && usuario ? usuario.nome : ''}</strong>?</p>
                </div>
                <div className="modal-footer ">
                    <button id='cancelar' type="button" className="btn btn-outline-secondary"
                            data-dismiss="modal">Cancelar
                    </button>
                    <button id='btnExcluir' type="button" className="btn btn-laranja float-left" data-dismiss="modal"
                            onClick={() => excluir()}>Excluir
                    </button>
                </div>
            </div>
        </div>
    </div>);

const ModalConfirmacaoInativacaoUsuario = ({inativar, atualizarCheckBox}) => (
    <div className="modal fade" id="ModalConfirmacaoInativacaoConfiguracao" tabIndex="-1" role="dialog"
         aria-labelledby="ModalConfirmacaoInativacaoConfiguracao" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-body texto-centralizado">
                    <p>Confirmar inativação do usuário? </p>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-outline-secondary"
                            data-dismiss="modal" onClick={() => atualizarCheckBox()}>Cancelar
                    </button>
                    <button type="button" className="btn btn-azul float-left" data-dismiss="modal"
                            onClick={() => inativar()}>Desativar
                    </button>
                </div>
            </div>
        </div>
    </div>);

export class UsuarioPlataforma extends React.Component {
    excluir() {
        this.props.exclurUsuarioPlataformaWeb(this.props.usuarioSelecionado.id)
            .then(() => {
                this.props.buscarUsuarios();
                showSuccessMsg('Usuário excluido com sucesso!')
            })
    }

    atualizarCheckBox() {
        document.getElementById(this.props.usuarioSelecionado.id).checked = true;
    }

    exibirInativacao() {
        if (this.props.usuario.rolesName.length) {
            return <input data-toggle="modal"
                          id={this.props.usuario.id}
                          data-target="#ModalConfirmacaoInativacaoConfiguracao"
                          className="checkbox-custom"
                          type="checkbox"
                          defaultChecked={this.props.usuario.rolesName.length}
                          onClick={() => this.props.selecionarUsuario(this.props.usuario)}/>
        }

        return <input className="checkbox-custom"
                      type="checkbox"
                      id={this.props.usuario.id}
                      defaultChecked={this.props.usuario.rolesName.length}
                      onClick={() => this.ativar()}/>
    }

    ativar() {
        this.props.ativarUsuarioPlataformaWeb(this.props.usuario.id).then(() => {
            showSuccessMsg('Usuário ativado com sucesso!');
            this.props.buscarUsuarios();
        })
    }

    exibirStatus() {
        if (this.props.usuario.rolesName.length) {
            return (<span className="txt-ativo">Ativo</span>);
        }
        return (<span className="txt-inativo">Inativo</span>);
    }


    iconeBloqueioDesbloqueio() {
        if (this.props.usuario.bloqueado) {
            return <i className="material-icons nav-icon" style={{color: 'red'}}>&#xe899;</i>
        }
        return <i className="material-icons nav-icon">&#xe898;</i>
    }

    inativar() {
        this.props.desativarUsuarioPlataformaWeb(this.props.usuarioSelecionado.id).then(() => {
            showSuccessMsg('Usuário desativado com sucesso!');
            this.props.buscarUsuarios();
        });
    }

    resetarSenha(id) {
        this.props.resetarSenhaUsuarioPlataformaWeb(id).then(() => {
            showSuccessMsg('Senha resetada com sucesso!');
        });
    }

    render() {
        return (
            <div className="geral">
                <div className="resumo">
                    <div className="row">
                        <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                            <span className="titulo-mobile">Nome:&nbsp;</span>{this.props.usuario.nome}
                        </div>
                        <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                            <span className="titulo-mobile">CPF:&nbsp;</span>{this.props.usuario.cpfCnpj}
                        </div>
                        <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2" style={{overflowWrap: 'break-word'}}>
                            <span className="titulo-mobile">E-mail:&nbsp;</span>{this.props.usuario.email}
                        </div>
                        <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                            <span className="titulo-mobile">Telefone:&nbsp;</span>{this.props.usuario.telefone}
                        </div>
                        <div className="col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1" style={{overflowWrap: 'break-word'}}>
                            <span className="titulo-mobile">Plataforma:&nbsp;</span>{this.props.usuario.plataforma}
                        </div>
                        <div className="col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1">
                            <span className="titulo-mobile">Data de criação:&nbsp;</span>{this.props.usuario.dataCriacao}
                        </div>
                        <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                            <div className="acoes">
                                <div className="botoes">
                                    <button type="button" className="btn btn-excluir"
                                            data-toggle="modal" key={this.props.usuario.id}
                                            title="Excluir"
                                            data-target="#modalConfirmacaoExclusaoUsuario"
                                            onClick={() => this.props.selecionarUsuario(this.props.usuario)}>
                                        <i className="material-icons nav-icon">&#xe872;</i>
                                    </button>
                                    <button type="button" className="btn btn-editar"
                                            data-toggle="modal"
                                            title="Editar"
                                            data-target='#modalCadastrarUsuarioPlataforma'
                                            onClick={() => this.props.selecionarUsuario(this.props.usuario)}>
                                        <i className="material-icons nav-icon">&#xe150;</i>
                                    </button>
                                    <button type="button" className="btn btn-editar"
                                            data-toggle="modal"
                                            title="Resetar senha"
                                            onClick={() => this.resetarSenha(this.props.usuario.id)}>
                                        <i className="material-icons nav-icon">&#xe5d5;</i>
                                    </button>
                                </div>
                                <div className="botoes">
                                    <span className="titulo-mobile tm-status">Status:&nbsp;</span>
                                    <div className="custom-btn-status ativo">
                                        {this.exibirInativacao()}
                                        <label htmlFor={this.props.usuario.id}
                                               className="checkbox-custom-label"/>
                                        {this.exibirStatus()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalConfirmacaoExclusaoUsuario excluir={this.excluir.bind(this)}
                                                 usuario={this.props.usuarioSelecionado}/>
                <ModalConfirmacaoInativacaoUsuario inativar={this.inativar.bind(this)}
                                                   atualizarCheckBox={this.atualizarCheckBox.bind(this)}/>

            </div>
        )
    }
}

export function mapStateToProps(state) {
    return {
        usuarioSelecionado: state.usuarioSelecionado
    }
}

export default connect(mapStateToProps, {
    changeFieldValue,
    selecionarUsuario,
    exclurUsuarioPlataformaWeb,
    desativarUsuarioPlataformaWeb,
    ativarUsuarioPlataformaWeb,
    resetarSenhaUsuarioPlataformaWeb
})(reduxForm({
    form: 'formularioAlterarUsuario'
})(UsuarioPlataforma))
